import { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

// components
import { Link } from 'dibs-elements/exports/Link';
import Contact1stdibsModal from '../../contact1stdibs/Contact1stdibsModal';

import styles from '../Footer/LinkColumn/LinkColumnItem.scss';

// helpers
import { trackFooterNavigationClick } from '../../helpers/trackingHelpers';

type Props = {
    trackingLabel: string;
};

const Contact1stdibsFooterLink: FunctionComponent<Props> = ({ trackingLabel }) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    return (
        <li className={styles.item}>
            <Link
                onClick={event => {
                    setIsContactModalOpen(true);
                    trackFooterNavigationClick({ label: trackingLabel }, event);
                }}
                className={styles.contact1stdibsLink}
                dataTn="footer-contact-1stdibs"
            >
                <FormattedMessage
                    id="dbl.Footer.site_links_contact_1stdibs"
                    defaultMessage="Get Help"
                />
            </Link>
            <Contact1stdibsModal
                isOpen={isContactModalOpen}
                placement="globalFooter"
                onClose={() => setIsContactModalOpen(false)}
            />
        </li>
    );
};

export default Contact1stdibsFooterLink;
